import { type CountryCode } from '@constants'
import { isCountryCode } from '@dni-multisite/is-country-code'
import { DEFAULT_COUNTRY_CODE } from '../constants'

const STM_COUNTRY_SEGMENT_REGEX = /^\/shepherdtech-market\/([a-z]{2})(\/|$)/

/**
 * 從 pathname 解析當前 STM 站點的 country code。
 *
 * 注意：App.tsx 的路由定義 `:countryCode(hk)?` 控制哪些 country segment 會被
 * React Router match，新增國家時需同步更新該 pattern。
 */
export const getStmCountryFromPath = (pathname: string): CountryCode => {
  const segment = pathname.match(STM_COUNTRY_SEGMENT_REGEX)?.[1]?.toUpperCase()
  return isCountryCode(segment) ? segment : DEFAULT_COUNTRY_CODE
}
